import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

import { hasStoredAccounts } from "../data/auth/crossTabSession"
import { refreshLoginStaticData } from "../data/auth/loginStaticData"

/**
 * parentOnlyBridge — une route PARTAGÉE entre l'élève, le tuteur et le parent, qui choisit son
 * chemin AU RENDU.
 *
 * Le parent a l'écran du design system ; l'élève et le tuteur gardent le corps legacy, l'écran du
 * design system n'ayant été ni dessiné ni recetté pour eux. Le booléen arrive par `connect`, comme
 * pour le corps legacy, pour que le pont lui-même n'appelle aucun hook avant sa branche : les deux
 * chemins ne doivent jamais monter le même arbre de hooks (`ports/CLAUDE.md` § 6).
 *
 * L'écran ports ne reçoit que `route` : il prend sa navigation par `useNavigation()`, comme tous
 * les autres écrans des ports. Le corps legacy, lui, garde son sac de props intact.
 */
export const parentOnlyBridge = (DsScreen, LegacyScreen) => {
    const Bridge = (props) =>
        props.isParentModeForDs ? <DsScreen route={props.route} /> : <LegacyScreen {...props} />

    return connect((state) => ({ isParentModeForDs: !!state.data.family?.isParentMode }))(Bridge)
}

/**
 * loginScreen — un écran de la connexion, sur le design system pour tout le monde.
 *
 * Il lance à son montage la lecture sans compte (`refreshLoginStaticData`), qui porte l'interrupteur
 * de la mise à jour au lancement (`launchUpdateFF`) aux appareils déconnectés : rien d'autre ne la
 * lance pour eux. Rien n'attend la réponse. L'écran des ports ne reçoit que `route`.
 */
export const loginScreen = (DsScreen) => {
    const Screen = ({ refreshLoginStaticData: refresh, route }) => {
        useEffect(() => {
            refresh()
        }, [])
        return <DsScreen route={route} />
    }

    return connect(null, { refreshLoginStaticData })(Screen)
}

/**
 * welcomeBridge — l'accueil de la pile déconnectée (`menu`).
 *
 * Un appareil sans compte enregistré a l'accueil du design system, qui passe aussitôt à la connexion :
 * l'ancien accueil (le carrousel) n'existe plus. Un appareil qui a des comptes garde l'écran d'aujourd'hui, qui l'envoie à « Qui
 * utilise Masteur ? ».
 *
 * Décidé au montage (un `useState` avant la branche) : un accueil ouvert sans
 * compte le reste quand une connexion en ajoute un par-dessus lui (une adresse `/login` ouverte
 * directement le pose dessous). Un accueil ouvert avec des comptes rend l'écran des comptes tant qu'il
 * en reste, et celui du design system quand il n'en reste aucun (« Retirer la famille ») : il n'a
 * alors plus personne vers qui renvoyer.
 */
export const welcomeBridge = (DsScreen, LegacyScreen) => {
    const Bridge = ({ hasAccounts, ...props }) => {
        const [openedWithAccounts] = useState(hasAccounts)
        return openedWithAccounts && hasAccounts ? <LegacyScreen {...props} /> : <DsScreen route={props.route} />
    }

    return connect((state) => ({ hasAccounts: hasStoredAccounts(state.data) }), {})(Bridge)
}
